import React, {useState} from 'react';
import {Alert, Modal, StyleSheet, Text, Pressable, View, TouchableOpacity, TouchableWithoutFeedback} from 'react-native';

export default function StatModal({modalVisible, setModalVisible, word, gameOver, won}) {

  return (
    <View style={styles.centeredView}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {setModalVisible(false)}}
      >
        <TouchableOpacity 
          style={styles.centeredView}
          activeOpacity={1} 
          onPressOut={() => {setModalVisible(false)}}
        >
          <TouchableWithoutFeedback style={styles.centeredView}>
            <View style={styles.modalView}>
              {
                gameOver 
                ? 
                  <Text style={styles.modalText}>
                    {
                      won 
                      ?
                        <Text style={styles.modalText}>
                          Congrats, you figured out the word: <Text style={styles.word}>{word}</Text>!
                        </Text>
                      :
                        <Text style={styles.modalText}>
                          The word is <Text style={styles.word}>{word}</Text>. Don't give up! Try again next time.
                        </Text>
                    }
                  </Text> 
                : 
                <Text style={styles.modalText}>Please finish making your guesses to reveal the word.</Text> 
              }
            </View>
          </TouchableWithoutFeedback>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // border: '1px solid black',
    // marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 30,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: '#F194FF',
  },
  buttonClose: {
    backgroundColor: '#2196F3',
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },
  word: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
  }
});